export const GET_500_USERS = { filter: { perPage: 500 } }
